import {useMemo, useState} from 'react'
import DeleteUser from '../Modal/DeleteUser'

export function useDeleteOwnerUser(callBackFn: () => void) {
  const [show, setShow] = useState(false)
  const [deleteId, setDeleteId] = useState('')

  const DeleteModal = useMemo(
    () => (
      <DeleteUser
        show={show}
        handleClose={() => {
          setShow(false)
          setDeleteId('')
        }}
        deletedId={deleteId}
        message='Are you sure, you want to delete this user ?'
        description='this will delete data permanently'
        callbackFn={() => {
          setDeleteId('')
          setShow(false)
          if (callBackFn) {
            callBackFn()
          }
        }}
      />
    ),
    [callBackFn, deleteId, show]
  )

  return {
    setShowDeleteModal: setShow,
    setDeleteId: setDeleteId,
    DeleteModal: DeleteModal,
  }
}
